// extracted by mini-css-extract-plugin
module.exports = {"cls-1":"CircleCheckAnimation_cls-1__2_gKJ","cls-2":"CircleCheckAnimation_cls-2__2bquZ","cls-4":"CircleCheckAnimation_cls-4__1wF_2","cls-3":"CircleCheckAnimation_cls-3__17nic"};